import axios from 'axios';

const axiosNoInterceptor = axios.create();

// No interceptors added here
export default axiosNoInterceptor;